import { BooleanBox } from './boolean-box';

export default BooleanBox;
